import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'
import 'select2'

export default class extends Controller {
  static targets = ["select"]

  connect() {
    $(this.selectTarget).select2({
      dropdownAutoWidth: true
    }).on("select2:select", () => {
      this.submitForm();
    });
  }

  disconnect() {
    $(this.selectTarget).select2('destroy');
  }

  submitForm() {
    this.element.closest('form').submit();
  }
}
